/* PROTOCOL flow v6 · reconciliation pass, 1 Aug 2026

   Two things were agreed and validated in the working mockup
   (FLOW1_nogate_v2.html) but never actually carried into the Shopify port:

   1. Header copy on join-protocol still read "Complete your test and save"
      with "Bundle to save up to $750", written for a member who had just
      filled in the form we removed, and using the pre-recalculation number.
      h1/eyebrow/lede are hardcoded inside protocol-style-2.liquid, not in
      section settings, so this replaces them by text match after render.

   2. "$54/mo billed annually - cancel anytime" (#total-sub) sat directly
      above a second line reading "Secure checkout - Cancel anytime", so
      the membership terms said cancel anytime twice on one screen. Agreed
      fix was to drop the #total-sub line entirely once the cart is empty,
      since the trust line under the button already covers it. This was
      built for the mockup's CSS but the rule never shipped.

   6 Aug 2026 · HCSAR remediation, ref MOH ENF/IP/259/2026.

   The replacement lede still ended with "Bundle to save up to $900.", so
   the compliant server copy was being overwritten with non-compliant copy
   on every page view. Saving language removed from both the h1 and the
   lede. Do not reintroduce "save", "discount", "free", "offer" or
   "preferential rate" here.

   Also fixes the visible copy swap. The server paints the old hardcoded
   header first and this script replaced it only after DOMContentLoaded,
   so the old headline was readable for a beat on every load. The header
   now starts hidden in protocol-flow-v6-fouc.css and is revealed here
   once the text is correct. reveal() runs on every exit path, including
   when the copy has been edited in admin and no swap is needed, so the
   header can never stay hidden. The stylesheet also carries a timed
   fallback that reveals it regardless if this script never runs.

   6 Aug 2026 · summary label. The order summary savings row is hardcoded
   as "Bundle savings" in protocol-style-2.liquid (join-protocol) but as
   "Member savings" in protocol-addons-style.liquid (add-ons, renew), so
   the same row was named two different things depending on which page a
   member landed on. Normalised to "Member savings" here, matching the
   add-ons flow. The figure itself is untouched: the discount is real and
   is applied at checkout, and hiding it from a transaction summary would
   be worse than showing it. Only the wording is standardised. */
(function(){
  'use strict';

  var NEW_EYEBROW = 'Optional add-ons';
  var NEW_H1 = 'Complete your test at member pricing';
  var NEW_LEDE = 'Optional additions at member pricing, from the same sample, charged once.';
  var OLD_H1_MARKERS = ['Complete your test and save', 'What could cost you'];
  var SUMMARY_LABEL = '🏷 Member savings';

  function reveal(panel){
    if(!panel) return;
    ['.eyebrow', 'h1', '.lede'].forEach(function(sel){
      var el = panel.querySelector(sel);
      if(el) el.style.visibility = 'visible';
    });
  }

  function fixHeader(){
    var panel = document.getElementById('panel-1');
    if(!panel) return;
    var h1 = panel.querySelector('h1');
    if(!h1){ reveal(panel); return; }
    if(h1.dataset.v6copy === '1'){ reveal(panel); return; }

    var isOldCopy = OLD_H1_MARKERS.some(function(m){ return h1.textContent.indexOf(m) > -1; });
    if(!isOldCopy){ reveal(panel); return; }   /* don't overwrite if someone has already edited it in admin */

    var eb = panel.querySelector('.eyebrow');
    var lede = panel.querySelector('.lede');
    if(eb) eb.textContent = NEW_EYEBROW;
    h1.textContent = NEW_H1;
    if(lede) lede.textContent = NEW_LEDE;
    h1.dataset.v6copy = '1';
    reveal(panel);
  }

  /* The row is hidden until an add-on is selected and is shown by the
     page's own syncSummary(), which writes the amount but never the
     label, so setting the text once here is enough. Runs again on the
     500ms pass in case the summary is rendered late. */
  function fixSummaryLabel(){
    var label = document.querySelector('#savings-row .sl');
    if(label && label.textContent.indexOf('Member savings') === -1){
      label.textContent = SUMMARY_LABEL;
    }
  }

  function boot(){
    fixHeader();
    fixSummaryLabel();
    setTimeout(function(){ fixHeader(); fixSummaryLabel(); }, 500);
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
